import request from "@/utils/request";

function touristFlowGetPoiList(data){    // 获取景点列表
    return request({
        url: "touristFlow/getPoiList",
        method: "POST",
        data:data
    })
}

function touristFlowGetTouristsFlowLine(data){    // 获取客流折线图
    return request({
        url: "touristFlow/getTouristsFlowLine",
        method: "POST",
        data:data
    })
}

function touristFlowGetTouristsFlowHourHeat(data){   // 获取时间段客流和时承载量
    return request({
        url: "/touristFlow/getTouristsFlowHourHeat",
        method: "POST",
        data:data
    })
}

function touristFlowGetTouristFlowDayHeat(data){     //获取日承载量
    return request({
        url: "/touristFlow/getTouristFlowDayHeat",
        method: "POST",
        data:data
    })
}

function touristFlowSetDayCarringCapacity(data){    // 动态配置日承载量
    return request({
        url: "touristFlow/setDayCarringCapacity",
        method: "POST",
        data:data
    })
}

function touristFlowSetHourCarringCapacity(data){  //动态配置实时承载量
    return request({
        url: "touristFlow/setHourCarringCapacity",
        method: "POST",
        data:data
    })
}

export {
    touristFlowGetPoiList,
    touristFlowGetTouristsFlowLine,
    touristFlowGetTouristsFlowHourHeat,
    touristFlowGetTouristFlowDayHeat,
    touristFlowSetDayCarringCapacity,
    touristFlowSetHourCarringCapacity
}
